<template>
    <section id="payment-data">
        <div class="list-group-item collapse-element d-flex justify-content-between align-items-center">
            <b>{{ $t('co.payment_data.variable-title', { steps: getSteps }) }}</b>
            <b-button variant="text" v-if="!isVisible" @click="openCollapse">
                <font-awesome-icon icon="far fa-pencil" />
            </b-button>
        </div>
        <b-collapse
            class="list-group-item checkout-payment-box "
            tag="div"
            v-model="isVisible"
        >

        <update-payment-method
            v-if="entry !== null && product !== null"
            :subscription="entry"
            :product="product"
            @payment-method-selected="paymentMethodSelected"
        ></update-payment-method>

        </b-collapse>
    </section>
</template>

<script>
import { BCollapse, BButton } from 'bootstrap-vue'
import {EventBus} from '../../event-bus'
import UpdatePaymentMethod from "./UpdatePaymentMethod.vue"

export default {
    name: 'CheckoutPaymentData',
    components: {
        BCollapse,
        BButton,
        UpdatePaymentMethod
    },
    props: {
        entry: null,
        product: null,
        customer: {
            type: Object,
            required: true
        },
        numberOfSteps: {
            type: Number,
        },
    },
    data() {
        return {
            isVisible: false,
            isRendered: false
        }
    },
    methods: {
        init() {
            this.isVisible = true
        },
        paymentMethodSelected(payload, callback) {
            this.$axios.put('api/v1/checkout/update_subscription', {
                subscription_uuid: this.entry.uuid,
                stripe_source: payload
            }).then(response => {
                this.isVisible = false
                this.googleAnalyticsPaymnentEvent()
                EventBus.$emit('checkout-open-step-4', null);
                document.getElementById('handover-data').scrollIntoView()
                if (callback) {
                    callback()
                }
            }).catch(() => {
                if (callback) {
                    callback()
                }
            })
        },
        openCollapse() {
            EventBus.$emit('close-all-collapses', null)
            this.$nextTick(() => {
                this.init()
            })
        },
        closeCollapse() {
            this.isVisible = false
        },
        googleAnalyticsPaymnentEvent(){
            if(process.env.MIX_VUE_APP_ACTIVATE_GOOGLE_ANALYTICS && this.$gtag !== undefined){
                this.$gtag.event('add_payment_info', {
                    currency: this.entry.price_plan.currency.toUpperCase(),
                    items: [
                        {
                            item_id: this.product.id,
                            item_name: this.product.model.title,
                            item_brand: this.product.brand.title,
                            item_category: this.product.category.title,
                            subsidiary_id: this.$root.whitelabel.sub_id(),
                            price: this.entry.price_plan.price,
                            mileage: localStorage.selectedMileage,
                            duration: localStorage.selectedDuration
                        }
                    ]
                })
            }
        }
    },
    mounted() {
        EventBus.$on('close-all-collapses', this.closeCollapse)
        EventBus.$on('checkout-open-step-3', this.init);
        EventBus.$on('payment-method-selected', this.paymentMethodSelected);
    },
    computed: {
        getSteps(){
            return this.numberOfSteps
        }
    },
}
</script>
